module.exports = __webpack_public_path__ + "img/logoblack.9f4db33e.svg";